"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useRef, useState } from 'react';
import { AlertCircleIcon } from '@autoguru/icons';
import { Box, Button, Heading, Icon, Inline, MinimalModal, Section, Stack, Text, useTextStyles } from '@autoguru/overdrive';
import clsx from 'clsx';
import { BROWSER_WARNING_SHOWN_FLAG } from './browserWarningFlag';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//@ts-ignore
export const SupportedBrowsersBoundary = ({
  children,
  errorFallback,
  errorTitle: _errorTitle = 'Your browser is out of date!',
  browsers,
  errorMessage: _errorMessage = "It looks like you're using an older version. To get the best speed, security, and to ensure all our site's features work correctly, we recommend a quick update."
}) => {
  const isSupported = useRef(browsers.test(navigator.userAgent));

  // Use a window-scoped flag to ensure the warning is only shown once per page
  const hasShownWarning = typeof window !== 'undefined' && window[BROWSER_WARNING_SHOWN_FLAG];
  const [showStats, setShowStats] = useState(!isSupported.current && !hasShownWarning);

  // Set the browser warning flag as soon as the warning is shown (no useEffect)
  if (showStats && typeof window !== 'undefined' && !window[BROWSER_WARNING_SHOWN_FLAG]) {
    window[BROWSER_WARNING_SHOWN_FLAG] = true;
  }

  // When the modal is shown, set the global flag
  const handleDismiss = () => {
    setShowStats(false);
  };
  if (isSupported.current) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (errorFallback) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: errorFallback
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MinimalModal, {
      hideBackdrop: true,
      onRequestClose: handleDismiss,
      isOpen: showStats,
      children: /*#__PURE__*/_jsx(Section, {
        width: "small",
        children: /*#__PURE__*/_jsx(Box, {
          width: "full",
          paddingX: "5",
          paddingY: "4",
          backgroundColour: "black900",
          borderRadius: "xl",
          borderColor: "default",
          borderWidth: "1",
          children: /*#__PURE__*/_jsxs(Stack, {
            alignItems: "end",
            space: "5",
            children: [/*#__PURE__*/_jsxs(Inline, {
              noWrap: true,
              space: "3",
              children: [/*#__PURE__*/_jsx(Icon, {
                className: clsx(useTextStyles({
                  colour: 'warning'
                })),
                size: "large",
                icon: AlertCircleIcon
              }), /*#__PURE__*/_jsxs(Stack, {
                space: "3",
                children: [/*#__PURE__*/_jsx(Heading, {
                  as: "h2",
                  colour: "white",
                  children: _errorTitle
                }), /*#__PURE__*/_jsx(Text, {
                  as: "p",
                  size: "3",
                  colour: "white",
                  children: _errorMessage
                })]
              })]
            }), /*#__PURE__*/_jsx(Button, {
              size: "small",
              variant: "danger",
              onClick: handleDismiss,
              children: "Dismiss"
            })]
          })
        })
      })
    }), children]
  });
};